<!-- My Profile Section Start Here -->
<section class="fullWidthCls myProfileSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="myProfileConSec">
        <h2 class="paddingLeftCls">
          <span class="">
						<i class="cusIconSize material-icons">&#xE7FD;</i>
					</span> My Profile</h2>
        <div class="col s12 m12 l12">
          <div class="myProfileDetailSecCls">
            <div class="card white">
              <div class="card-content #000">
                <ul class="profile-section">
                  <li>
                    <div class="profile-content">
                      <aside><img src="./assets/images/profile-name-img.png" /></aside>
                      <label>First Name</label>
                      <span>{{ dashboardModel.userInfo.firstName }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="profile-content">
                      <aside><img src="./assets/images/profile-name-img.png" /></aside>
                      <label>Last Name</label>
                      <span>{{ dashboardModel.userInfo.lastName }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="profile-content">
                      <aside><img src="./assets/images/profile-no-of-exam-img-n.png" /></aside>
                      <label>No. of Exams Purchased</label>
                      <span>{{ dashboardModel.userInfo.totalExam }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="profile-content">
                      <aside><img src="./assets/images/profile-email-img-n.png" /></aside>
                      <label>Email</label>
                      <span>{{ dashboardModel.userInfo.email }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- My Exam Details start Here -->
<section class="fullWidthCls myExamsSec">
  <div class="container-fluid">
    <div class="row">
      <div class="myExamsConSec">
        <div class="paddingLeftCls myExamsTitleSec">
          <span class="btnLargeCus addNCls">
						<i class="material-icons">&#xE896;</i>
					</span>
          <h2>My Exams :</h2>
          <button class="dropdown-button" md-icon-button [mdMenuTriggerFor]="myExamsDropDown">
						<span class="myExamDrpDwnTitle"> {{ (dashboardModel && dashboardModel.selectedExamFilterType)?dashboardModel.selectedExamFilterType.text:'' }}</span>
						<span class="caretCustomDefine"></span>
					</button>
          <md-menu class="dropdown2" #myExamsDropDown="mdMenu">
            <button md-menu-item *ngFor="let filter of dashboardModel.examsFilterTypes" (click)="changeExamsList(filter)">
							<md-icon>
								<img [src]="filter.iconUrl" />
							</md-icon>
							<span>{{ filter.text }}</span>
						</button>
          </md-menu>
        </div>
        <!-- Calendar Pick Date Section  -->
        <div *ngIf="dashboardModel
							&& dashboardModel.selectedExamFilterType
							&& dashboardModel.selectedExamFilterType.showDates" class="col s12 m12 l12">
          <div class="calendarSelectBox">
            <ul class="calendarDatePick">
              <li class="relClsGlobal">
                <div class="input-field col s12">
                  <md-input-container class="frmDatePickerCls">
                    <input id="fromDate" class="datepicker validate" mdInput [mdDatepicker]="pickerFromDt" placeholder="From date" [ngModel]="dashboardModel.examsListFDate"
                      (ngModelChange)="dashboardModel.examsListFDate = $event" (change)="dateChanged()">
                    <md-datepicker-toggle mdSuffix [for]="pickerFromDt"></md-datepicker-toggle>
                  </md-input-container>
                  <md-datepicker #pickerFromDt [startAt]="dashboardModel.examsListFDate" (selectedChanged)="dateChanged($event,'f')"></md-datepicker>
                </div>
              </li>
              <li class="relClsGlobal">
                <div class="input-field col s12">
                  <md-input-container class="toDatePickerCls">
                    <input id="toDate" class="datepicker validate" mdInput [mdDatepicker]="pickerToDt" placeholder="To date" [ngModel]="dashboardModel.examsListTDate"
                      (ngModelChange)="dashboardModel.examsListTDate = $event" (change)="dateChanged()">
                    <md-datepicker-toggle mdSuffix [for]="pickerToDt"></md-datepicker-toggle>
                  </md-input-container>
                  <md-datepicker #pickerToDt [startAt]="dashboardModel.examsListTDate" (selectedChanged)="dateChanged($event,'t')"></md-datepicker>
                </div>
                <p class = "validate date-error" *ngIf="isexamsListTDateError">To date can not be less than From date</p>
              </li>
            </ul>

          </div>
        </div>
        <div class="examScheduleBoxContainer">
          <!-- Oops Box Start Here -->
          <div *ngIf="(submitInProcess==false
							&& (dashboardModel.examsList==undefined || dashboardModel.examsList.length <= 0));
							else examsListTemp" class="col s12 m6 l3">
            <div class="oopsBox card white borderBottomWhite">
              <div class="card-content #000">
                <div class="examNotFoundBox">
                  <img src="./assets/images/oops-box-sec-img.png" alt="" />
                  <h3 class="examNameNotFound">None</h3>
                  <span class="OopsDescInfo">Not able to see your exam?
										<a href="mailto:certification-team@redhat.com;">Contact Admin</a>
									</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Exams Dynamic Box Start Here -->
          <ng-template #examsListTemp>
            <div *ngFor="let exam of dashboardModel.examsList" class="col s12 m6 l3">
              <!-- Exam Scheduled/Rescheduled Box Start Here -->
              <!-- New examStatusCode -->
              <a *ngIf="_utility.effectiveExamStatusIs(exam,'SCHEDULED')" (click)="setExamDetails(exam)"
                alt="">
                <div class="card white {{ _utility.examBorderBottomCSSClass(exam) }}">
                  <div class="card-content #000">
                    <div class="examDateTimeSec">
                      <span class="examDate roundedCorner {{ _utility.examBackgroundCSSClass(exam) }} floatLeftCls">Exam on {{ exam.examStartDateTime | dateTimeFormat:_appConfig.dateFormat }}</span>
                      <span [title]="(exam.examStartDateTime | dateTimeFormat:_appConfig.timeFormatExamCards) + ' ' + exam.timeZone" class="examTime roundedCorner {{ _utility.examBackgroundCSSClass(exam) }} floatRightCls">{{ exam.examStartDateTime | dateTimeFormat:_appConfig.timeFormatExamCards }} {{ exam.timeZone }}</span>
                    </div>
                    <p class="elgbltyCode">Eligibility Code: {{ exam.isRetake ? exam.originalEligibilityCode : exam.eligibilityCode }} {{ exam.isRetake ? "Retake Scheduled" : "Scheduled" }}</p>
                    <h3 class="examName {{ _utility.examNameCSSClass(exam) }}">
                      {{ exam.examCode }}
                    </h3>
                    <p class="examDetail">{{ exam.examName }}</p>
                    <p class="examDetail"></p>
                    <div class="examCardFooterSec">
                      <span class="examExpDetail">Expiration Date</span>
                      <span class="examExpDate roundedCorner redBG">{{ exam.eligibilityExpirationDate | dateTimeFormat:_appConfig.dateFormat }}</span>
                      <span class="examExpAlert">Expires in {{ _utility.daysUntil(_utility.convertToDateTime(exam.eligibilityExpirationDate)) }} Day(s)</span>
                    </div>
                  </div>
                </div>
              </a>
              <!-- Exam to Schedule Box Start Here -->
              <!-- New examStatusCode -->
              <a *ngIf="_utility.effectiveExamStatusIs(exam,'EXAMSTOSCHEDULE')" (click)="setExamDetails(exam)"
                alt="">
                <div class="card white {{ _utility.examBorderBottomCSSClass(null) }}">
                  <div class="card-content #000">
                    <div class="examDateTimeSec opacity0">
                      <span class="examDate roundedCorner {{ _utility.examBackgroundCSSClass(null) }} floatLeftCls">&nbsp;</span>
                      <span class="examTime roundedCorner {{ _utility.examBackgroundCSSClass(null) }} floatRightCls">&nbsp;</span>
                    </div>
                    <p class="elgbltyCode">Eligibility Code: {{ exam.isRetake ? exam.originalEligibilityCode : exam.eligibilityCode }} {{ exam.isRetake ? "Retake Available" : "Unscheduled" }}</p>
                    <h3 class="examName {{ _utility.examNameCSSClass(null) }}">{{ exam.examCode }}</h3>
                    <p class="examDetail">{{ exam.examName }}</p>
                    <p class="examDetail"></p>
                    <div class="examCardFooterSec">
                      <span class="examExpDetail">Expiration Date</span>
                      <span class="examExpDate roundedCorner redBG">{{ exam.eligibilityExpirationDate | dateTimeFormat:_appConfig.dateFormat }}</span>
                      <span class="examExpAlert">Expires in {{ _utility.daysUntil(_utility.convertToDateTime(exam.eligibilityExpirationDate)) }} Day(s)</span>
                    </div>
                  </div>
                </div>
              </a>
              <!-- Exam Expired Box Start Here -->
              <!-- New examStatusCode -->
              <a *ngIf="_utility.effectiveExamStatusIs(exam, 'EXAMSEXPIRED')" (click)="setExamDetails(exam)" alt="">
                <div class="disabledCardConView card white {{ _utility.examBorderBottomCSSClass(exam) }}">
                  <div class="card-content #000">
                    <div class="examDateTimeSec">
                      <span class="examDate roundedCorner {{ _utility.examBackgroundCSSClass(exam) }} floatLeftCls">Expired on {{ exam.eligibilityExpirationDate | dateTimeFormat:_appConfig.dateFormat }}</span>
                    </div>
                    <p class="elgbltyCode">Eligibility Code: {{ exam.isRetake ? exam.originalEligibilityCode : exam.eligibilityCode }} {{ exam.isRetake ? "Retake Expired" : "Expired" }}</p>
                    <h3 class="examName {{ _utility.examNameCSSClass(exam) }}">{{ exam.examCode }}</h3>
                    <p class="examDetail">{{ exam.examName }}</p>
                    <p class="examDetail"></p>
                    <div class="examCardFooterSec">
                      <span class="examExpDetail">Expiration Date</span>
                      <span class="examExpDate roundedCorner redBG">Expired</span>
                      <span class="examExpAlert">Expires in {{ _utility.daysUntil(_utility.convertToDateTime(exam.eligibilityExpirationDate)) }} Day(s)</span>
                    </div>
                  </div>
                </div>
              </a>
              <!-- Exam Taken Box Start Here -->
              <!-- New examStatusCode -->
              <a *ngIf="_utility.effectiveExamStatusIs(exam, 'COMPLETED')" (click)="setExamDetails(exam)"
                alt="">
                <div class="card {{ _utility.examBorderBottomCSSClass(exam) }} dashboard-card">
                  <div class="card-content">
                    <div class="examDateTimeSec">
                      <span class="examDate roundedCorner {{ _utility.examBackgroundCSSClass(exam) }} floatLeftCls">Exam on {{ exam.examStartDateTime | dateTimeFormat: _appConfig.dateFormat }}</span>
                      <span [title]="(exam.examStartDateTime | dateTimeFormat:_appConfig.timeFormatExamCards) + ' ' + exam.timeZone" class="examTime roundedCorner {{ _utility.examBackgroundCSSClass(exam) }} floatRightCls">{{ exam.examStartDateTime | dateTimeFormat:_appConfig.timeFormatExamCards }} {{ exam.timeZone }}</span>
                    </div>
                    <p class="elgbltyCode">Eligibility Code: {{ exam.isRetake ? exam.originalEligibilityCode : exam.eligibilityCode }} {{ exam.isRetake ? "Retake Completed" : "Completed" }}</p>
                    <h3 class="examName {{ _utility.examNameCSSClass(exam) }}">{{ exam.examCode }}</h3>
                    <p class="examDetail">{{ exam.examName }}</p>
                    <p class="examDetail"><md-icon>{{ exam.resultIcon }}</md-icon> {{exam.result}}</p>
                    <div class="examCardFooterSec hiddencls">
                      <span class="examExpDetail">Expiration Date</span>
                      <span class="examExpDate roundedCorner redBG">Expired</span>
                      <span class="examExpAlert">Expires in {{ _utility.daysUntil(_utility.convertToDateTime(exam.eligibilityExpirationDate)) }} Day(s)</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/dashboard/dashboard.component.html